<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/andon/record/listByPage" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item   :label="$t('shebeimingcheng')">
						<yi_cross_select multiple :component="'web_base_equipment_list'"
							:ids.sync="yt.conditions.equipments">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('yichangleixingmingcheng')">
						<el-select multiple filterable :clearable="true" v-model="yt.conditions.exceptionTypes">
							<el-option v-for="(item, index) in exceptionTypeList" :key="index" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({orderBy: 'createTime desc,triggerTime asc',status: 0})">{{$t('chongzhi')}}</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" :loading="scope.row.confirmLoading" @click="triggerBtn(scope.row)" v-if="utils.checkPower('web_andon_management_confirm_exception_update')">
							{{$t('querenyichang')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 确认异常 -->
			<template v-if="yt.editObj.action == 'querenyichang'">
				
			</template>
	
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_andon_management_confirm_exception_list',
		components: {

		},
		data() {
			return {
				exceptionTypeList: [],
				columns: [{
					label: 'shebeimingcheng',
					prop: 'equipment.name',
					// type: 'dictionary',
					// key: 'PARAMETER_TYPE',
					width: 130
				}, {
					label: 'yichangleixingmingcheng',
					prop: 'exceptionType.name',
					width: 130
				}, {
					label: 'yichangchufashijian',
					prop: 'triggerTime',
					type: 'time',
					// format: "YYYY-MM-DD"
				}, {
					label: 'chufaren',
					prop: 'triggerUser.nickname'
				}, {
					label: 'yichangmiaoshu',
					prop: 'description'
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 130,
					fixed: 'right'
				}]
			};
		},

		created() {
			setTimeout(() => {
				this.yt.conditions = {
					status: 0,
					orderBy: 'createTime desc,triggerTime asc',
				}
				this.yt.get(1)
				this.getExceptionType();
			}, 300)
		},
		methods: {
			triggerBtn(editObj) {
				this.$set(editObj, 'confirmLoading', true);
				let params = editObj;
				params.status = 1;
				this.http.post('/web/andon/record/update', params).then((res) => {
					this.utils.successMessage(this.$t(res.msg));
					this.yt.get(1);
				}).catch((msg) => {
					this.utils.errorMessage(msg);
				}).finally(() => {
					this.$set(editObj, 'confirmLoading', false);
				});
			},
			getExceptionType() {
				this.http.get('/web/andon/exceptionType/page', {
					params: {
						pageNum: 1,
						pageSize: 1000
					}
				}).then(res => {
					this.exceptionTypeList = res.data.rows
				})
			
			}
		}
	};
</script>
